<template>
  <div class="contact-container">
    <CustomModal 
    :type="modal.type"
    :open="modal.open">
      <template slot="modal_content">
        <p class="notification-text">{{modal.message}}</p>
      </template>
    </CustomModal>

    <form @submit.prevent="() => {}">
      <div class="grid-row">
        <div class="c-12">
          <h1>{{$_('contact_us')}}</h1>
          <p>{{$_('product_question')}}</p>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('reason')}}</label>
            <Select 
              :data="form_info.subject" 
              :placeholder="$_('subject')"
              :itemoption="['TCODE', 'TLIB']"
              @select-change="form_data.TCODE = $event.item"
            />
          </div>
          <div class="form-field">
            <label>{{$_('first_name')}} *</label>
            <Input 
              :type="'text'"
              :required="true"
              :ref="'tpnom'"
              @typing="form_data.TPNOM = $event" />
          </div>
          <div class="form-field">
            <label>{{$_('last_name')}} *</label>
            <Input 
              :type="'text'"
              :required="true"
              :ref="'tnom'"
              @typing="form_data.TNOM = $event" />
          </div>
          <div class="form-field">
            <label>{{$_('email')}} *</label>
            <Input 
              :type="'email'" 
              :required="true"
              :ref="'tmail'"
              :maxlength="40"
              class="uppercase"
              @typing="form_data.TMAIL = $event.toUpperCase()" />
          </div>
          <div class="form-field" v-show="form_data.TCODE === 'C'">
            <label>{{$_('order_reference')}}*</label>
            <Select 
              :placeholder="$_('order_reference')" 
              :itemoption="['TNCDE', 'treftncde']"
              @select-change="getTncde($event)"
              :search="true"
              :data="form_info.order"
              :required="true"
              :ref="'tncde'"
            /> 
          </div>
          <div class="form-field">
            <label>{{$_('message')}} *</label>
            <Textarea
              :required="true"
              :ref="'tcom'"
              @typing="form_data.TCOM = $event">
            </Textarea>
          </div>
          <div class="form-field">
            <div class="visit-card">
              <label for="files">+ {{$_('add_attachment')}}</label>
              <span class="nb-file">{{form_file.file_name !== '' ? '('+form_file.file_name+')' : '' }}</span>
              <input type="file" id="files" ref="contact_attachment" v-on:change="handleFileUpload()" />
            </div>
          </div>
          <div class="form-field">
            <span class="btn btn-submit" @click="sendContactForm()">{{$_('send').toUpperCase()}}</span>
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="company-info">
            <h3>{{$_('customer_service')}}</h3>
            <span>{{this.TINFOS_OUVERT}}</span>
            <span><a :href="`tel:+${this.TTEL_ADV}`">+{{this.TTEL_ADV}}</a></span>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import Select from '@/common/components/widget/Select'
import Input from '@/common/components/widget/Input/Input'
import Textarea from '@/common/components/widget/Textarea/Textarea'
import CustomModal from '@/common/components/widget/Modal/CustomModal';

import customerService from '@/modules/client/services/customerService'
import orderService from '@/modules/commande/services/orderService';

export default {
  name: 'Contact',
  data() {
    return {
      modal: {
        type: 'default',
        message: '',
        open: false,
        error_count: 0
      },
      form_info: {
        subject: Array(),
        order: Array(),
        pnum_ev: 0,
      },
      form_file: {
        file: Array(),
        nb_file: 0,
        file_name: ''
      },
      form_data: {
        TCODE: '',
        TPNOM: '',
        TNOM: '',
        TMAIL: '',
        TNCDE: '',
        TREF: '',
        TCOM: '',
      },
      already_send: false,
      TINFOS_OUVERT: '',
      TTEL_ADV: ''
    }
  },
  components: {
    Select,
    CustomModal,
    Input,
    Textarea
  },
  created() {
    customerService.getContactInfo()
    .then(res => {
      if(res.data.DS_O !== undefined) {
        this.form_info.subject = res.data.DS_O.OUT
      }
    });

    if( this.$store.getters['application/get_application_user'].id !== undefined &&
      this.$store.getters['application/get_application_company'].PCSOC !== undefined
    ) {

      customerService.getGeneralInfos().then(res => {

        if(res.data.DS_O !== undefined) {

          let infos = res.data.DS_O.OUT[0];

          this.TINFOS_OUVERT = infos.TINFOS_OUVERT;
          this.TTEL_ADV = infos.TTEL_ADV;
        }
      });
    }
    

    orderService.getOrder({
      plimit: 100,
      poffset: 0,
      fstatut: 100
    })
    .then(res => {
      if(res.data.DS_O !== undefined) {  
        
        res.data.DS_O.OUT.forEach(element => {
          
          element.treftncde = `${element.TREF} - ${element.TNCDE}`; 
          this.form_info.order.push(element);
        
        });
      }
    })
  },
  methods: {
    getTncde(event) {
      this.form_data.TNCDE = event.item;

      Object.values(this.form_info.order).map(val => {
        if(val.TNCDE === event.item) {
          this.form_data.TREF = val.TREF
        }
      })
    },
    sendContactForm() {


      if(this.already_send === false) {

      

        this.error_count = 0; 

        if(this.form_data.TCODE !== 'P') {

          if(this.$refs.tncde !== undefined && this.$refs.tncde.selected.TNCDE === undefined) {
            this.$refs.tncde.activate_required = true;
            ++this.error_count;
          } else {
            this.$refs.tncde.activate_required = false;
            this.error_count > 1 ? --this.error_count : 0;
          }
          
        }

        if(this.$refs.tpnom.currentValue === '') {
          this.$refs.tpnom.activate_required = true;
          ++this.error_count;
        } else {
          this.$refs.tpnom.activate_required = false;
          this.error_count > 1 ? --this.error_count : 0;
        }

        if(this.$refs.tnom.currentValue === '') {
          this.$refs.tnom.activate_required = true;
          ++this.error_count;
        } else {
          this.$refs.tnom.activate_required = false;
          this.error_count > 1 ? --this.error_count : 0;
        }

        if(this.$refs.tmail.currentValue === '') {
          this.$refs.tmail.activate_required = true;
          ++this.error_count;
        } else {
          this.$refs.tmail.activate_required = false;
          this.error_count > 1 ? --this.error_count : 0;
        }

        if(this.$refs.tcom.currentValue === '') {
          this.$refs.tcom.activate_required = true;
          ++this.error_count;
        } else {
          this.$refs.tcom.activate_required = false;
          this.error_count > 1 ? --this.error_count : 0;
        }
        
        if(this.error_count === 0) {

          let form_tmp = this.form_data;

          if(this.form_data.TCODE !== 'C') {
            delete form_tmp.TREF;
            delete form_tmp.TNCDE;
          }

          this.already_send = true;

          customerService.sendContactForm(form_tmp)
          .then(res => {
            if(res.data !== undefined && res.data.PNUM_EV !== undefined) {
              
              this.form_info.pnum_ev = res.data.PNUM_EV;

              customerService.uploadContactAttachment(this.form_file, this.form_info.pnum_ev)
              .then(response => {

                customerService.sendFilePath(response.data[0], this.form_info.pnum_ev)
                .then(res => {
                  setTimeout(() => {
                    window.location.reload(true)
                  }, 2000)
                })
              })
            
              this.modal.open = true;
              this.modal.type = 'success';
              this.modal.message = "Le message a bien été envoyé";

            } else {

              this.already_send = false;
              this.modal.open = true;
              this.modal.type = 'error';
              this.modal.message = "Une erreur est survenue lors de l'upload de la pièce jointe";
            }
          })
        }
        
      }
    },
    handleFileUpload() {
      this.form_file.file = this.$refs.contact_attachment.files;
      this.form_file.file_name = this.$refs.contact_attachment.files[0].name
    },
  }
};
</script>

<style scoped>
/deep/
.select-box {
  margin: 0px;
}
input[type="file"] {
  visibility:hidden;
}
.company-info h3 {
  font-family: 'Lato-Light';
  margin-bottom: 15px;
  font-size: var(--fz-md);
  font-weight: bold;
}
.company-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 300px;
  margin: auto;
}
.company-info span {
  display: block;
  font-family: 'Lato-Regular';
  font-size: var(--fz-md);
  color: #8B8B8B;
}
.notification-text {
  font-size: var(--fz-lg);
  text-align: center;
}
.nb-file {
  font-size: .7rem;
  display: inline-block;
  margin-left: 5px;
  font-weight: bold;
}
.btn-submit {
  display: inline-block;
  max-width: 150px;
  text-align: center;
}
/deep/
.input-text-container input {
  width: 100%;
}
/deep/
.input-text-container textarea {
  width: 100%;
}
/deep/
.uppercase input {
  text-transform: uppercase;
}
</style>